document.addEventListener('DOMContentLoaded', () => {

  const previewImg = document.getElementById('basePreviewImage');
  const titleEl = document.getElementById('baseTitle');
  const priceEl = document.getElementById('basePrice');
  const sizeWrap = document.getElementById('sizeOptions');
  const cta = document.getElementById('chooseArtBtn');

  let activeBase = Object.keys(window.BASE_PRODUCTS)[0];
  let selectedVariantId = null;
  let selectedSize = null;

  /* =========================
     READ VARIANT FROM URL
  ========================== */
  const params = new URLSearchParams(window.location.search);
  const variantFromUrl = params.get('variant');
  const sizeFromUrl = params.get('size');
  const materialFromUrl = params.get('material');


if (variantFromUrl) {

  for (const handle in window.BASE_PRODUCTS) {

    const product = window.BASE_PRODUCTS[handle];

    const matchedVariant = product.variants.find(v =>
      String(v.id) === String(variantFromUrl)
    );

    if (matchedVariant) {

      activeBase = handle;

      // 🔥 If size exists → match size inside SAME product
      if (sizeFromUrl) {
        const sizeMatchedVariant = product.variants.find(v => {
          const variantSize = v.title.split(' / ')[0];
          return variantSize.toLowerCase() === sizeFromUrl.toLowerCase();
        });

        if (sizeMatchedVariant) {
          selectedVariantId = sizeMatchedVariant.id;
          selectedSize = sizeMatchedVariant.title.split(' / ')[0];
        } else {
          selectedVariantId = matchedVariant.id;
          selectedSize = matchedVariant.title.split(' / ')[0];
        }

      } else {
        selectedVariantId = matchedVariant.id;
        selectedSize = matchedVariant.title.split(' / ')[0];
      }

      break;
    }
  }
}

if (materialFromUrl) {
  const cleanMaterial = materialFromUrl.toLowerCase().trim();

  // Add class to body
  document.body.classList.remove(
    'material-denim',
    'material-canvas',
    'material-leather'
  );

  document.body.classList.add('material-' + cleanMaterial);
}

if (!materialFromUrl && activeBase) {
  const product = window.BASE_PRODUCTS[activeBase];

  if (product.material) {
    document.body.classList.add('material-' + product.material.toLowerCase());
  }
}



  /* =========================
     ACTIVATE CORRECT THUMBNAIL
  ========================== */
  document.querySelectorAll('.base-option').forEach(btn => {
    btn.classList.remove('active');
    if (btn.dataset.handle === activeBase) {
      btn.classList.add('active');
    }
  });

  /* =========================
     RENDER BASE
  ========================== */
  function renderBase(handle) {

    const product = window.BASE_PRODUCTS[handle];
    if (!product) return;

    titleEl.textContent = product.title;
    priceEl.textContent = product.price;

    // 🔥 If variant from URL exists → use variant image
    if (selectedVariantId) {
      const matchedVariant = product.variants.find(v =>
        String(v.id) === String(selectedVariantId)
      );

      if (matchedVariant && matchedVariant.image) {
        previewImg.src = matchedVariant.image;
      } else {
        previewImg.src = product.image;
      }
    } else {
      previewImg.src = product.image;
    }

    sizeWrap.innerHTML = '';

    product.variants.forEach(v => {
      if (!v.available) return;

      const size = v.title.split(' / ')[0];
      const btn = document.createElement('button');

      btn.className = 'choose-size__btn';
      btn.textContent = size;

      // 🔥 Auto-select correct size
    if (selectedSize && size.toLowerCase() === selectedSize.toLowerCase()) {
        btn.classList.add('is-active');
        selectedSize = size;
      }

      btn.addEventListener('click', () => {
        document.querySelectorAll('.choose-size__btn')
          .forEach(b => b.classList.remove('is-active'));

        btn.classList.add('is-active');
        selectedVariantId = v.id;
        selectedSize = size;

        // 🔥 Update preview image when size clicked
       if (selectedSize && size.toLowerCase() === selectedSize.toLowerCase()) {
          btn.classList.add('is-active');
          selectedVariantId = v.id;
          selectedSize = size;

          if (v.image) {
            previewImg.src = v.image;
          }
        }


        validate();
      });

      sizeWrap.appendChild(btn);
    });

    validate();
  }

  /* =========================
     BASE SWITCHER
  ========================== */
  document.querySelectorAll('.base-option').forEach(btn => {
    btn.addEventListener('click', () => {

      document.querySelectorAll('.base-option')
        .forEach(b => b.classList.remove('active'));

      btn.classList.add('active');

      activeBase = btn.dataset.handle;
      selectedVariantId = null;
      selectedSize = null;

      renderBase(activeBase);
    });
  });

  /* =========================
     VALIDATION
  ========================== */
  function validate() {
    if (selectedVariantId) {
      cta.disabled = false;
      cta.classList.add('enabled');
    } else {
      cta.disabled = true;
      cta.classList.remove('enabled');
    }
  }

  /* =========================
     INITIAL LOAD
  ========================== */
  renderBase(activeBase);

  /* =========================
     NEXT PAGE
  ========================== */
cta.addEventListener('click', () => {
  if (!selectedVariantId) return;

  const product = window.BASE_PRODUCTS[activeBase];
  const matchedVariant = product.variants.find(
    v => String(v.id) === String(selectedVariantId)
  );

  if (!matchedVariant) return;

  const material = product.material
    ? product.material.toLowerCase().replace(/\s+/g, '-')
    : '';

  const baseHandle = activeBase;

  // 1. Dynamically check if the CURRENT page is in kiosk mode
  const urlParams = new URLSearchParams(window.location.search);
  const isKiosk = urlParams.get('kiosk') === 'true';

  // 2. Build the base URL
  let targetUrl = `/collections/jackets/products/jackets`
    + `?base=${selectedVariantId}`
    + `&baseHandle=${baseHandle}`
    + `&size=${matchedVariant.size}`
    + `&material=${material}`;

  // 3. Append kiosk=true only if it was present in the current URL
  if (isKiosk) {
    targetUrl += `&kiosk=true`;
  }

  window.location.href = targetUrl;
});
});
